// extracted by mini-css-extract-plugin
module.exports = {"container":"LabResultNotes_container__1vCRL"};